GameSlamStopButton = {};

GameSlamStopButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  button._flags.reelsSpinning = false;
  button._flags.reelsSlammed = false;
  button._flags.spinEventReceived = false;

  button.canEnable = function () {
    if (button._flags.allowSlamStop) {
      this.visible = true;
      return (
        this._flags.reelsSpinning &&
        !this._flags.reelsSlammed &&
        !this._flags.modal.active
      );
    } else {
      this.visible = false;
      return false;
    }
  };

  button.canShow = function () {
    if (gameController.isInWolfRun) {
      return false;
    }

    return this._flags.reelsSpinning || gameController.inFreeSpins;
  };

  button.onPressedCallback = function () {
    this._flags.reelsSlammed = true;
    gameController.doSlamStop();

    gameController.cashLink.doSlamStop();

    if (button.soundName !== "") button.playSound();
  };

  button.reelSpinStarted = function (spinTask) {
    this._flags.reelsSlammed = false;
    this._flags.reelsSpinning = true;
  };

  button.reelSpinEnded = function () {
    this._flags.reelsSpinning = false;
    this._flags.reelsSlammed = false;
  };

  button.gameCommitted = function () {
    this._flags.reelsSlammed = false;
    this._flags.reelsSpinning = true;
  };
  messageBus.subscribe(
    "spinner:stormLink",
    button.reelSpinStarted.bind(button)
  );
  messageBus.subscribe(
    "spinner:stormLinkEnd",
    button.reelSpinEnded.bind(button)
  );

  messageBus.subscribe(
    "spinner:SpinEvent",
    button.reelSpinStarted.bind(button)
  );
  messageBus.subscribe(
    "spinner:SpinEventDead",
    button.reelSpinEnded.bind(button)
  );
  messageBus.subscribe(
    "common:GameCommitted",
    button.gameCommitted.bind(button)
  );
  messageBus.subscribe("common:AbortGame", button.reelSpinEnded.bind(button));
  messageBus.subscribe(
    "common:GameCompleteEvent",
    button.reelSpinEnded.bind(button)
  );

  return button;
};

GameSlamStopButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
GameSlamStopButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "GameSlamStopButton",
  GameSlamStopButton.create,
  GameSlamStopButton.initialise,
  GameSlamStopButton.getFilesRequired
);
